import SampleAdded from 'components/GlobalModals/ProductSamplesModal/Minidrawer/SampleAdded/SampleAdded';

export default SampleAdded;
